import React from 'react';

import { Link } from 'gatsby';

import CDNImage from '../cdn-image';

import '../../../styles/common/promos/prints-shop-banner.scss';

const NewPrintsBanner = (props) => (
	<>
		{(props.path.substr(0, 5) !== '/shop' &&
		  props.path.substr(0, 8) !== '/product') && (
			
			<div
				role="complementary"
				aria-label="Promotional Banner"
				className={`sitewide-banner prints-shop-sitewide-banner`}
			>
				<Link to="/shop/fine-art-prints">
					<div className="mobile-contents">
						<div className="text-side">
							<span className="headline">
								Visit Our Prints Shop
							</span>
							<span className="message">
								All profits back into the project
							</span>
						</div>
						<div className="image-side">
							<CDNImage
								imagePath="/banners/prints-shop/prints-banner-3.jpg"
								height="386"
								alt="Blue Root print"
							/>
						</div>
					</div>
					<div className="hide-mobile-contents">
						<CDNImage
							imagePath="/banners/prints-shop/mobile-override.jpg"
							alt="Visit Our Prints Shop"
						/>
					</div>
					<div className="contents page-width">
						<span className="left-side">
							<div className="images">
								<div>
									<CDNImage
										imagePath="/banners/prints-shop/prints-banner-1a.jpg"
										height="453"
										alt="Ancient Courses print"
										className="print-1"
									/>
								</div>
								<div className="full-size-only">
									<CDNImage
										imagePath="/banners/prints-shop/prints-banner-2.jpg"
										height="438"
										alt="Eight Shadow Figures print"
										className="print-2"
									/>
								</div>
							</div>
						</span>
						<span className="details">
							<span className="headline">
								Explore Our Prints Store
							</span>
							<span className="print-details">
								Archival inks on premium art paper.<br />
								Unframed or framed ready to hang.<br />
								All profits back into the project.
							</span>
							<span className="shop-cta">
								Shop Now
							</span>
							<span className="shipping">
								<span className="shipping-headline">FREE SHIPPING</span>
								<span className="shipping-baseline">To US, UK, EU, Canada, and Australia.</span>
							</span>
						</span>
						<span className="right-side">
							<div className="images">
								<div className="full-size-only">
									<CDNImage
										imagePath="/banners/prints-shop/prints-banner-3.jpg"
										height="386"
										alt="Blue Root print"
										className="print-3"
									/>
								</div>
								<div>
									<CDNImage
										imagePath="/banners/prints-shop/prints-banner-4.jpg"
										height="445"
										alt="Meteor Shower print"
										className="print-4"
									/>
								</div>
							</div>
						</span>
					</div>
				</Link>
			</div>
		  )}
	</>
);

export default NewPrintsBanner;